<template>
  <div>
    <video ref="video" class="video border border-1 border-dark" width="256px" height="145px" autoplay="true"></video>
    <div>
      <canvas ref="canvas" class="canvas border border-dark" width="1920px" height="1080px" style="display: none"></canvas>
    </div>
    <!--
    <pre>{{$props}}</pre>
    <pre>{{$data}}</pre>
    -->
  </div>  
</template>

<script>
import _ from 'lodash'

const PROGRESS_THRESHOLD = 1000
const CONSTRAINT = {
  video: {
    width: 1920,
    height: 1080,
  }
}
const DELTA = [30, 30, 30]

export default {
  props: {
    enabled: { type: Boolean, require: true, },
    value: { type: String, },
  },
  data() {
    return {
      inLobby: false,
      inQuest: false,
      infoDisplayOnRightSide: false,
      intervalId: -1,
    }
  },
  mounted() {
    if (this.enabled) {
      this.open()
    }
  },
  watch: {
    value: function(deviceId) {
      this.close()

      if (! deviceId) return

      this.open()
    }
  },
  methods: {
    open() {
      if (! navigator.mediaDevices.getUserMedia ) return

      this.close()

      if (! this.value) return

      let constraint = _.cloneDeep(CONSTRAINT)
      constraint.video.deviceId = { exact: this.value }
      navigator.mediaDevices.getUserMedia(constraint).then(srcObject => {
        // スロットルをかけるとクエスト開始直後に素早くクエスト終了すると認識漏れが起きるが、周回なら問題ないので漏れは気にしない
        let video = this.$refs.video
        video.srcObject = srcObject
        this.intervalId = setInterval(this.onVideoProgress, PROGRESS_THRESHOLD)
      })
      .catch(e => {
        console.log(e)
        throw e
      })
    },
    close() {
      let video = this.$refs.video

      if (! video.srcObject) return

      video.srcObject.getTracks().forEach(t => t.stop())
      video.srcObject = null
      clearInterval(this.intervalId)
    },
    onVideoProgress() {
      let video = this.$refs.video
      let canvas = this.$refs.canvas
      if (! canvas) return  // 開発中は自動リロードによって undefined になるタイミングがある

      let context = canvas.getContext('2d', { alpha: false })
      context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight)
      
      let eq = pred => pred
      let neq = pred => !pred

      let inLobby =
        match(context, { name: 'メンバーリスト', pred: eq, min: [127, 118, 70], xys: [
          [ 30, 260],  // 左上
          [550, 260],  // 右上
          [ 30, 435],  // 左下
          [550, 435],  // 右下
        ]})
        && 
        match(context, { name: 'アクションスライダー', pred: eq, min: [40, 90, 120], xys: [
          [1620, 1002],  // 左下
          [1771,  942],  // 右上
        ]})
      // console.log(`inLobby = ${inLobby}`)

      let inQuest = 
        match(context, { name: '体力ゲージ', pred: eq, min: [112, 200, 164], xys: [
          [174, 80],  // お団子を食べていない状態の左端
          [380, 80],  // お団子を食べていない状態の中央
          [580, 80],  // お団子を食べていない状態の右端
        ]})
        &&
        match(context, { name: 'スタミナゲージ', pred: eq, min: [225, 193, 20], xys: [
          [174, 108],  // お団子を食べていない状態の左端
          [380, 108],  // お団子を食べていない状態の中央
          [580, 108],  // お団子を食べていない状態の右端
        ]})
        &&
        match(context, { name: '修練場の武器名', pred: neq, min: [90, 80, 40], max: [160, 150, 120], xys: [
          [ 72, 424],  // 1
          [ 72, 457],  // 2
          [324, 442],  // 3
        ]})
        // &&
        // (
        //   match(context, { name: 'ターゲット', pred: eq, min: [225, 50, 40], xys: [
        //     [1889,  95],  // 矢印の一番太い部分左端
        //     [1895,  95],  // 矢印の一番太い部分中央
        //     [1899,  95],  // 矢印の一番太い部分右端
        //     [1895,  99],  // 矢印の先端
        //   ]})
        //   ||
        //   match(context, { name: '小型討伐', pred: eq, min: [210, 140, 70], xys: [
        //     [143, 413],  // 剣の先端左
        //     [150, 418],  // 剣の先端右
        //     [145, 415],  // 剣の中央
        //     [139, 423],  // 剣の柄近く
        //   ]})
        // )
        &&
        match(context, { name: 'ホーム画面', pred: neq, delta: [5, 5, 5], xys: [
          [   9,    9],  // 左上
          [1909,    9],  // 右上
          [   9, 1069],  // 左下
          [1909, 1069],  // 右下
        ]})
      // console.log(`inQuest = ${inQuest}`)
      
      this.infoDisplayOnRightSide =
        (
          // ステータス、スキル詳細、装備詳細、オトモ情報、ウィッシュリスト(登録リスト)
          match(context, { name: 'ステータス', pred: eq, min: [10, 50, 75], max: [20, 60, 90], xys: [
            [1576, 142],  // 左上
            [1822, 142],  // 右上
            [1576, 164],  // 左下
            [1822, 164],  // 右下
          ]})
          &&
          (
            // オトモ情報以外
            match(context, { name: 'ZL・ZRの矢印', pred: eq, min: [240, 240, 240], xys: [
              [1560, 194],  // ZL
              [1840, 194],  // ZR
            ]})
            ||
            // オトモ情報
            match(context, { name: 'ZL・ZRの矢印', pred: eq, min: [240, 240, 240], xys: [
              [1563, 198],  // ZL
              [1842, 198],  // ZR
            ]})
          )
        )
        ||
        (
          // 詳細マップ、大型モンスターリスト、小型モンスターリスト、環境生物リスト、手記帳、基本操作指南、武器操作指南
          match(context, { name: '詳細マップ', pred: eq, min: [74, 38, 14], max: [84, 49, 24], xys: [
            [   0,    0],
            [1919,    0],  // 中間値として左上が適切ではないため
            [   0, 1079],
            [1919, 1079],
          ]})

          // match(context, { debug: true, name: '詳細マップ', pred: eq, min: [70, 40, 5], max: [100, 70, 30], delta: [45, 45, 30], xys: [
          //   [   0,    0],  // 左上   89, 56, 21
          //   [1919,    0],  // 右上  108, 75, 41  // 中間値として左上が適切ではないため
          //   [   0, 1079],  // 左下  129, 99, 56
          //   [1919, 1079],  // 右下  108, 80, 39
          // ]})
        )

      this.inLobby ||= inLobby
      this.inQuest ||= inQuest

      this.$emit('update-status', {
        inLobby: inLobby,
        inQuest: inQuest,
        infoDisplayOnRightSide: this.infoDisplayOnRightSide,
      })

      // クエスト出発判定はサンブレイクで変更あり。クエスト出発と拠点間移動のローディング画面が同じであるため。
      if (this.inLobby && ! inLobby && this.inQuest) {
        // console.log('クエストへ出発しました')
        this.inLobby = false
        this.$emit('start-quest')
      }

      // クエスト帰還判定はサンブレイクで変更なし。
      if (this.inQuest && ! inQuest && this.inLobby) {
        // console.log('クエストから帰還しました')
        this.inQuest = false
        this.$emit('return-quest')
      }

      //console.log(`lobby = ${this.inLobby}(${inLobby}), quest = ${this.inQuest}(${inQuest})`)
    },
  },
}

function match(context, criteria) {
  let c = criteria

  let pixels = c.xys.map(xy => {
    let p = context.getImageData(xy[0], xy[1], 1, 1)
    return {
      xy: xy,
      color: [p.data[0], p.data[1], p.data[2]],
    }
  })

  if (c.min) {
    let errors = pixels.filter(p => p.color[0] < c.min[0] || p.color[1] < c.min[1] || p.color[2] < c.min[2])
    if (errors.length != 0) {
      c.debug && errors.forEach(p => {
        console.log(`${c.name}: error: min: (${p.xy[0]}, ${p.xy[1]}): ${p.color[0]}(${c.min[0]}), ${p.color[1]}(${c.min[1]}), ${p.color[2]}(${c.min[2]})`)
      })
      return c.pred(false)
    }
  }

  if (c.max) {
    let errors = pixels.filter(p => c.max[0] < p[0] || c.max[1] < p[1] || c.max[2] < p[2])
    if (errors.length != 0) {
      c.debug && errors.forEach(e => {
        console.log(`${c.name}: error: max: (${e.xy[0]}, ${e.xy[1]}): ${e.color[0]}(${c.max[0]}), ${e.color[1]}(${c.max[1]}), ${e.color[2]}(${c.max[2]})`)
      })
      return c.pred(false)
    }
  }

  let average = [
    _.meanBy(pixels, p => p.color[0]),
    _.meanBy(pixels, p => p.color[1]),
    _.meanBy(pixels, p => p.color[2]),
  ]
  let delta = c.delta ?? DELTA
  let errors = pixels
    .filter(p => {
      return delta[0] < Math.abs(p.color[0] - average[0]) ||
             delta[1] < Math.abs(p.color[1] - average[1]) ||
             delta[2] < Math.abs(p.color[2] - average[2])
    })
    .map(p => {
      return {
        ...p,
        delta: [
          Math.abs(p.color[0] - average[0]),
          Math.abs(p.color[1] - average[1]),
          Math.abs(p.color[2] - average[2]),
        ],
      }
    })

  if (errors.length != 0) {
    c.debug && ! c.pred(false) && errors.forEach(p => {
      console.log(`${c.name}: error: delta: (${p.xy[0]}, ${p.xy[1]}): ${p.delta[0]}(${delta[0]}), ${p.delta[1]}(${delta[1]}), ${p.delta[2]}(${delta[2]})`)
    })
    return c.pred(false)
  }

  return c.pred(true)
}
</script>
